import { sortData } from '../../../../../../utils/fuctions/sortData';

export function sortQueueArrays({
  arrayLabels,
  arrayAtendidas,
  arrayAbandonadas,
  orderByGraphics
}) {
  const combinedData = arrayLabels?.map((label, index) => ({
    label,
    attended: arrayAtendidas[index],
    abandoned: arrayAbandonadas[index],
    total: (arrayAtendidas[index] || 0) + (arrayAbandonadas[index] || 0)
  }));

  const sortedData = sortData(combinedData, 'total', orderByGraphics || 'DESC');

  return {
    labels: sortedData.map((item) => item.label),
    attended: sortedData.map((item) => item.attended),
    abandoned: sortedData.map((item) => item.abandoned)
  };
}
